export const SEARCH_PROFILES_REQUEST = "@PROFILES/SEARCH_PROFILES_REQUEST";
export const SEARCH_PROFILES_SUCCESS = "@PROFILES/SEARCH_PROFILES_SUCCESS";
export const SEARCH_PROFILES_FAILURE = "@PROFILES/SEARCH_PROFILES_FAILED";
export const SET_SELECTED_PROFILE = "@PROFILES/SET_SELECTED_PROFILE";
export const UPDATE_PROFILE_INFO = "@PROFILES/UPDATE_PROFILE_INFO";
export const FETCH_PROFILE_REQUEST = "@PROFILES/FETCH_PROFILE_REQUEST";
export const FETCH_PROFILE_SUCCESS = "@PROFILES/FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_FAILURE = "@PROFILES/FETCH_PROFILE_FAILURE";
